import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

export function isEmbeddedMode(): boolean {
  return environment.allowIframe && detectEmbedded();
}

function detectEmbedded(): boolean {
  try {
    return globalThis.self !== globalThis.top;
  } catch {
    // Cross-origin parent: access to window.top throws — treat as embedded.
    return true;
  }
}

function getAllowedParentOrigin(): string | null {
  const referrerOrigin = globalThis.document.referrer ? new URL(globalThis.document.referrer).origin : null;
  const parentOrigin = referrerOrigin ?? globalThis.location.ancestorOrigins?.[0] ?? null;

  return parentOrigin && environment.allowedOrigins.includes(parentOrigin) ? parentOrigin : null;
}

@Injectable({ providedIn: 'root' })
export class IframeService {
  readonly isEmbedded: boolean = isEmbeddedMode();

  notifyAssessmentCreated(assessmentId: number): void {
    if (!this.isEmbedded) return;

    const message = JSON.stringify({ assessmentId });
    const targetOrigin = getAllowedParentOrigin();

    if (!targetOrigin) return;

    globalThis.parent.postMessage(message, targetOrigin);
  }
}
